import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import TemporaryIllnessesPage from "./temporary-illnesses-page";

export default (
  <Route path="temporary-illnesses">
    <Route
      index
      element={
        <Protected
          path="/admin/temporary-illnesses"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <TemporaryIllnessesPage />
        </Protected>
      }
    />
  </Route>
);
